var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid background-header",style:({backgroundImage: ("url('/" + (this.$staticPath) + "/" + (this.backgroundUrl) + "')")})},[_c('div',{staticClass:"overlay"}),_vm._v(" "),_c('div',{staticClass:"text text-center"},[_c('h1',[_c('i',[_vm._v(_vm._s(_vm.text))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-651c7aed","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/COMMON/HeaderBar.vue
// module id = null
// module chunks = 